import * as React from "react";
import {Fragment} from "react";
import JobAgentChangeNotification from "../../../model/notification/assignee/job/JobAgentChangeNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: JobAgentChangeNotification
}

/**
 * Agent change notification toast body.
 */
const NotificationJobAgentChangeBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Job {props.notification.data.getJobReferenceNumber()}</div>
			<div className={"toast-body"}>
				Agent changed from <b>{props.notification.displayPreviousAssignee()} </b>
				to <b>{props.notification.displayCurrentAssignee()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationJobAgentChangeBody;